"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const common_1 = require("../../../@inax/common");
let InaxExcelService = 
/**
 * Service class to communicate with inax to handle excel read and write operations.
 * @class InaxExcelService
 * @classdesc Service class to communicate with inax to handle excel read and write operations.
 * @author insite-gmbh
 */
class InaxExcelService {
    /**
     * constructor.
     * @param {Http} _http http service to handle web api calls.
     * @param {Configuration} _configuration configuration specifies signalRHubs, serveraddress,... .
     * @param {ProfileService} _profileService this service adds authentication data to the webApiRequests.
    */
    constructor(_http, _configuration, _profileService) {
        this._http = _http;
        this._configuration = _configuration;
        this._profileService = _profileService;
    }
    /***********************************************************************
     *          WEB API
     * ********************************************************************/
    /**
     * Determine all sheet names of the workbook.
     * @method sheets
     * @param {string} bookname This parameter is the name of the workbook.(Filename)
     * @return {Observable<boolean>} returns a Observable which is called with a list of the existing sheet
     * names when the operation was finished.
     */
    sheets(bookname) {
        let accessUrl = this._configuration.buildRestUrl("Excel", "GetSheets") + "?bookName=" + bookname;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    /**
     * Create a new sheet and/or a new workbook (File)
     * @method create
     * @param {string} bookname This parameter is the name of the workbook.(Filename)
     * @param {string} sheetName This parameter is the name of the sheet we want to create.
     * @return {Observable<Response>} returns a http response to see if the operation succeeded.
     */
    create(bookName, sheetName) {
        let accessUrl = this._configuration.buildRestUrl("Excel", "Create") + "?bookName=" + bookName + "&sheetName=" + sheetName;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, null, { headers });
    }
    /**
     * read a given datareference (for details see documentation of the matrix modul)
     * @method read
     * @param {string} dataRef specifies the read operation
     * @return {Observable<Result<any>>} returns the read result when the operation finished.
     */
    read(dataRef) {
        let accessUrl = this._configuration.buildRestUrl("Excel", "Read") + "?dataRef=" + dataRef;
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.get(accessUrl, { headers }).map(res => res.json());
    }
    /**
     * write a value to the given datareference (for details see documentation of the matrix modul)
     * @method write
     * @param {string} dataRef specifies the write operation.
     * @param {string} val the data to write.
     * @return {Observable<Response>} returns a http response to see if the operation succeeded.
     */
    write(dataRef, val) {
        let accessUrl = this._configuration.buildRestUrl("Excel", "Write");
        let headers = this._profileService.addAuthorization(new http_1.Headers());
        return this._http.post(accessUrl, val, { headers });
    }
};
InaxExcelService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http,
        common_1.InaxConfiguration,
        common_1.ProfileService])
], InaxExcelService);
exports.InaxExcelService = InaxExcelService;
